const defaultPageZoom = 0.998;

// Pdf elements — populated in init() once the page DOM is ready
let pdfCanvas;
let context;
let prevButton;
let nextButton;
let pageInfo;
let zoomInButton;
let zoomOutButton;
let zoomLevelDisplay;

// video player element
let videoContainer;
let videoPlayer;
let noVideo;

function initElements() {
  pdfCanvas = document.getElementById('pdf-canvas');
  context = pdfCanvas.getContext('2d');
  prevButton = document.getElementById('prev-page');
  nextButton = document.getElementById('next-page');
  pageInfo = document.getElementById('page-info');
  zoomInButton = document.getElementById('zoom-in');
  zoomOutButton = document.getElementById('zoom-out');
  zoomLevelDisplay = document.getElementById('zoom-level');

  videoContainer = document.getElementById('video-container');
  videoPlayer = document.getElementById('video-player');
  noVideo = document.getElementById('no-video');
}

let pdfInstance = null;
let currentPage = 1;
let totalPages = 1;
let currentScale = 2;
let zoomLevel = 1;
let lastPageSize = 0;

let pdfPathHex = '';
let videoPaths = {};

function loadSettings(config) {
  pdfPathHex = config.pdfPathHex;
  videoPaths = config.videoPaths;

  if (!videoPaths) {
    videoContainer.style.display = 'none';
  }
}

// Function to update video based on the current page
function updateVideo(pageNum) {
  if (!videoPaths) {
    return;
  }

  const videoUrl = videoPaths[pageNum];
  if (videoUrl) {
    // Embed video URL with autoplay enabled
    videoPlayer.src = `${videoUrl}?autoplay=1`;
    videoPlayer.style.display = 'block';
    noVideo.style.display = 'none';
  } else {
    // Fallback or empty the video player if no video is mapped
    videoPlayer.src = '';
    videoPlayer.style.display = 'none';
    noVideo.style.display = 'flex';
  }
}

function renderPage(pageNum, newScale) {
  return pdfInstance.getPage(pageNum).then((page) => {
    let scale;
    // calculate scale if not provided
    if (!newScale) {
      // get page size
      const pageWidth = page.view[2] - page.view[0];
      // const pageRatio = pageWidth / pageHeight;

      // use document width to calculate the zoom level to fill the screen.
      const viewportWidth = document.documentElement.clientWidth;
      scale = (viewportWidth / pageWidth) * defaultPageZoom;
      currentScale = scale;
    } else {
      scale = newScale;
    }

    const viewport = page.getViewport({ scale: scale * zoomLevel });

    // Get device pixel ratio for Retina support
    const devicePixelRatio = window.devicePixelRatio || 1;

    // Resize canvas to match the scaled viewport, considering Retina (devicePixelRatio)
    pdfCanvas.width = viewport.width * devicePixelRatio;
    pdfCanvas.height = viewport.height * devicePixelRatio;

    // Set the canvas style to match the actual viewport size
    pdfCanvas.style.width = `${viewport.width}px`;
    pdfCanvas.style.height = `${viewport.height}px`;

    // Scale context to match devicePixelRatio for Retina displays
    context.scale(devicePixelRatio, devicePixelRatio);

    // render

    // Render the PDF page into the canvas
    const renderTask = page.render({
      canvasContext: context,
      viewport,
    });

    return renderTask.promise.then(() => {
      pageInfo.textContent = `Page ${currentPage} / ${totalPages}`;
      prevButton.disabled = currentPage <= 1;
      nextButton.disabled = currentPage >= totalPages;
    });
  });
}

function updateZoom(zoomChange) {
  const previousViewport = pdfCanvas.getBoundingClientRect();
  const previousScrollX = window.scrollX;
  const previousScrollY = window.scrollY;

  zoomLevel = Math.min(Math.max(zoomLevel + zoomChange, 0.5), 3); // Clamp zoom level between 50% and 300%
  zoomLevelDisplay.textContent = `${Math.round(zoomLevel * 100)}%`;

  renderPage(currentPage, currentScale).then(() => {
    // Calculate new scroll position to maintain viewport center
    const newViewport = pdfCanvas.getBoundingClientRect();
    const deltaX = (newViewport.width - previousViewport.width) / 2;
    const deltaY = (newViewport.height - previousViewport.height) / 2;
    window.scrollTo(previousScrollX + deltaX, previousScrollY + deltaY);
  });
}

let resizeTimeout;
function handleResize() {
  if (resizeTimeout) {
    clearTimeout(resizeTimeout);
  }
  // wait until user stop resizing the window
  resizeTimeout = setTimeout(() => {
    let zoomRatio = 1;
    // Check if the page size has changed
    if (lastPageSize !== document.documentElement.clientWidth) {
      // get new scale between lastPageSize and current page size
      zoomRatio = document.documentElement.clientWidth / lastPageSize;
      lastPageSize = document.documentElement.clientWidth;

      // update current scale
      currentScale *= zoomRatio;
    }

    renderPage(currentPage, currentScale);
  }, 500);
}

// Load the PDF
function loadPdf() {
  const { hostname, protocol } = window.location;
  const path = atob(pdfPathHex);
  const pdfUrl = `${protocol}//${hostname}${path}`;

  const pdfjsLib = window['pdfjs-dist/build/pdf'];
  pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js';
  pdfjsLib.getDocument(pdfUrl).promise.then((pdf) => {
    pdfInstance = pdf;
    totalPages = pdf.numPages;

    lastPageSize = document.documentElement.clientWidth;
    renderPage(currentPage);
    updateVideo(currentPage); // Initialize video for the first page
  }).catch((err) => {
    console.error('Error loading PDF:', err);
  });
}

function setupEvents() {
  // Modify navigation button click handlers
  prevButton.addEventListener('click', () => {
    if (currentPage > 1) {
      currentPage -= 1;
      renderPage(currentPage, currentScale);
      updateVideo(currentPage); // Update the video
    }
  });

  nextButton.addEventListener('click', () => {
    if (currentPage < totalPages) {
      currentPage += 1;
      renderPage(currentPage, currentScale);
      updateVideo(currentPage); // Update the video
    }
  });

  // Zoom buttons
  zoomInButton.addEventListener('click', () => updateZoom(0.2)); // Zoom in by 20%
  zoomOutButton.addEventListener('click', () => updateZoom(-0.2)); // Zoom out by 20%

  // page resize
  window.addEventListener('resize', handleResize);

  // // Disable right-click
  // document.addEventListener('contextmenu', (e) => e.preventDefault());

  // // Disable text selection
  // document.addEventListener('selectstart', (e) => e.preventDefault());
}

export default {
  init(config) {
    initElements();
    loadSettings(config);
    loadPdf();
    setupEvents();
  },
};
